
import PropTypes from 'prop-types'
import React from 'react'

const Calendar = props => {
  const style = {
    width: '23px',
    height: '26px'
  }
  return (
    <div style={style} className={props.class}>
      <svg width='23' height='25' viewBox='445 121 23 25' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none' fillRule='evenodd' strokeLinecap='round' strokeLinejoin='round' stroke='#FFF' strokeWidth='1.5'>
          <path d='M448.618 144.864c-.942 0-1.705-.701-1.705-1.566v-16.914c0-.865.763-1.566 1.705-1.566h1.78s-.325 1.524.113 1.524h3.158c.438 0 .112-1.524.112-1.524h5.513s-.325 1.524.112 1.524h3.101c.438 0 .112-1.524.112-1.524h1.763c.942 0 1.705.701 1.705 1.566v16.914c0 .865-.763 1.566-1.705 1.566h-15.764zM466.049 129.182h-18.68M452.163 123.451v-.527M461.005 123.451v-.527M456.515 137.565v-4.1M456.515 140.515v-.272' />
        </g>
      </svg>
    </div>
  )
}

Calendar.propTypes = {
  class: PropTypes.string
}

Calendar.displayName = 'Calendar'

export default Calendar



// WEBPACK FOOTER //
// ./ui/icons/calendar.js